import { QueryCache, QueryClient, MutationCache } from "@tanstack/react-query";
import { UnauthorizedError } from "@/utils/auth/UnauthorizedError";
import { ApiError } from "@/apis/naniexpert/ApiError";

// 401 已在攔截器導向登入頁，全域略過不再提示
const ignoreUnauthorized = (error: unknown) => {
  if (error instanceof UnauthorizedError) return;
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: ignoreUnauthorized }),
  mutationCache: new MutationCache({ onError: ignoreUnauthorized }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      // NOTE: 401 會在攔截器導向登入頁，不重試；
      // ApiError（含 403/429/500 等業務或伺服器狀態）為後端明確回應，重試無意義，
      // 只有網路／未知錯誤才重試。
      retry: (failureCount, error) => {
        if (error instanceof UnauthorizedError) return false;
        if (error instanceof ApiError) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});
